import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import MarketingResourcesPage from "@/modules/resources/pages/marketing";
import { object, enum as zodEnum } from "zod";

export const Route = createFileRoute(
  "/(auth)/_headed/resources/_layout/marketing"
)({
  component: RouteComponent,
  validateSearch: zodValidator(
    object({
      category: zodEnum(["marketing_poster", "web_story"]).default(
        "marketing_poster"
      ),
    })
  ),
});

function RouteComponent() {
  return <MarketingResourcesPage />;
}
